module.exports = "<main-entity-component  [entityChildElement]=\"entityChildElements\"\r\n                        [carouselItemList]=\"entityOperationElement\" \r\n                        (entitySetChild)=\"GetEntityChild($event)\" ></main-entity-component>\r\n<selected-child-component [entitySelectElement]=\"entityselectChild\" ></selected-child-component>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/entityWithChilds/entity-with-childs.component.html
// module id = ../../../../../src/app/private/entity/entityWithChilds/entity-with-childs.component.html
// module chunks = main